var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90.311287mm",
    height: "135.46666mm",
    viewBox: "0 0 90.311287 135.46666",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-59.436904,-59.70537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g883",
    transform: "matrix(0.26458333,0,0,0.26458333,36.859215,59.70537)",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g828",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g826",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 256,0 C 161.896,0 85.333,76.563 85.333,170.667 c 0,28.25 7.063,56.26 20.49,81.104 L 246.667,506.5 c 1.875,3.396 5.448,5.5 9.333,5.5 3.885,0 7.458,-2.104 9.333,-5.5 L 406.229,251.687 c 13.375,-24.76 20.438,-52.771 20.438,-81.021 C 426.667,76.563 350.104,0 256,0 Z",
    id: "path824",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g830",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g832",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g834",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g836",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g838",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g840",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g842",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g844",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g846",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g848",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g850",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g852",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g854",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g856",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g858",
    style: {
      fill: "#18b3b3",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      strokeWidth: 10.6234
    },
    id: "path2134",
    cx: 104.59254,
    cy: 105.62543,
    r: 33.445217
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#18b3b3",
      fillOpacity: 1,
      strokeWidth: 3.58962
    },
    id: "path1077",
    cx: 104.59254,
    cy: 105.62543,
    r: 22.465088
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPoint);
export default __webpack_public_path__ + "static/media/default_point.4c419a17b58703f49e554e9d97bc023d.svg";
export { ForwardRef as ReactComponent };